"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryExecSyntaxForExpression = tryExecSyntaxForExpression;
exports.tryExecSyntaxForEventStatement = tryExecSyntaxForEventStatement;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const errors_1 = require("../errors");
function tryExecSyntaxForExpression(syntax, context, exp, iterableIndex) {
    try {
        const output = (0, pi_syntax_tools_1.execSyntax)(syntax, context);
        if (typeof output === "number" && Number.isNaN(output)) {
            throw new errors_1.ExpressionExecutionError("Output of expression is NaN (not a number)", exp, iterableIndex);
        }
        return output;
    }
    catch (e) {
        if (e instanceof Error) {
            throw new errors_1.ExpressionExecutionError(e.message, exp, iterableIndex);
        }
        throw e;
    }
}
function tryExecSyntaxForEventStatement(syntax, context, statement, eventSet, iterableIndex) {
    try {
        const output = (0, pi_syntax_tools_1.execSyntax)(syntax, context);
        if (typeof output === "number" && Number.isNaN(output)) {
            throw new errors_1.EventExecutionError("Output of event statement is NaN (not a number)", statement, eventSet, iterableIndex);
        }
        return output;
    }
    catch (e) {
        if (e instanceof Error) {
            throw new errors_1.EventExecutionError(e.message, statement, eventSet, iterableIndex);
        }
        throw e;
    }
}
//# sourceMappingURL=execute-syntax.js.map